import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {userSearchResultStateSelector} from './user-search-result-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {RegionSettings} from 'src/openapi/admin/models/RegionSettings';
import type {UserSearchCriteria} from 'src/openapi/admin/models/UserSearchCriteria';
import type {UserSearchFiltering} from 'src/openapi/admin/models/UserSearchFiltering';
import type {UserSortField} from 'src/openapi/admin/models/UserSortField';

type LcdSubscriptionsData = Record<string, Record<string, Array<RegionSettings>>>;

export const userGroupsSearchResultLcdSubscriptionsSlice = getCachedTableDataSlice<
    LcdSubscriptionsData,
    UserSearchCriteria,
    UserSortField,
    UserSearchFiltering
>('userGroupsSearchResultLcdSubscriptions');

export const userGroupsSearchResultLcdSubscriptionsActions = userGroupsSearchResultLcdSubscriptionsSlice.actions;

const userGroupsSearchResultLcdSubscriptionsCacheSelector: CachedTableCacheSelector<LcdSubscriptionsData>
    = state => state.accountPage.tabs.usersAndGroups.userSearchResult.lcdSubscriptions.cache;
export const userGroupsSearchResultLcdSubscriptionsDataSelector: CachedTableDataSelector<LcdSubscriptionsData>
    = state => state.accountPage.tabs.usersAndGroups.userSearchResult.lcdSubscriptions;
export const userGroupsSearchResultLcdSubscriptionsResultSelector = getCachedTableResultSelector(
    userGroupsSearchResultLcdSubscriptionsCacheSelector,
    userSearchResultStateSelector,
);
